import { httpV2 } from "../http.js";

const InboxService = {
  get: () => httpV2.get(`inbox`),
  set: (inbox) => httpV2.post(`inbox`, inbox),
  getInboxes: (page, filter = "", pageSize = 20) =>
    httpV2.get(
      `inbox/search?page=${page}&filter=${filter}&pageSize=${pageSize}`,
    ),
  getPersonalInbox: (personalInboxId, page, filter = "", pageSize = 20) =>
    httpV2.get(
      `inbox/personal/${personalInboxId}?page=${page}&filter=${filter}&pageSize=${pageSize}`,
    ),
  getInboxThread: (threadId) => {
    return httpV2.get(`inbox/thread/${threadId}`);
  },
  getPaginatedInboxThread: (threadId, { offset = 0, limit = null } = {}) => {
    let url = `inbox/thread/${threadId}/paginated`;
    const params = [];
    if (offset) params.push(`offset=${offset}`);
    if (limit) params.push(`limit=${limit}`);
    if (params.length) url += `?${params.join("&")}`;
    return httpV2.get(url);
  },
  getPersonalPaginatedInboxThread: (
    threadId,
    personalInboxId,
    { offset = 0, limit = null } = {},
  ) => {
    let url = `inbox/thread/${threadId}/${personalInboxId}/paginated`;
    const params = [];
    if (offset) params.push(`offset=${offset}`);
    if (limit) params.push(`limit=${limit}`);
    if (params.length) url += `?${params.join("&")}`;
    return httpV2.get(url);
  },
  getThreadOverview: (threadId) =>
    httpV2.get(`inbox/thread/${threadId}/overview`),
  setMeta: (threadId, data) =>
    httpV2.post(`inbox/thread/${threadId}/meta`, data),

  setPersonalMeta: (thread_id, personal_inbox_id, token, set) =>
    httpV2.post(
      `inbox/thread/meta/${thread_id}/${token}/${personal_inbox_id}/${set ? "add" : "remove"}`,
    ),

  togglePersonalMeta: async (thread_id, personal_inbox_id, token) =>
    httpV2.post(
      `inbox/thread/meta/${thread_id}/${token}/${personal_inbox_id}/toggle`,
    ),

  createRecipient: (recipient) => httpV2.post(`teams`, recipient),
  updateRecipient: (recipient) =>
    httpV2.put(`teams/${recipient.recipient_id}`, recipient),
  bulkUpdateSchedules: (recipientIds, schedule) =>
    httpV2.put(`teams/bulk-schedules`, { recipient_ids: recipientIds, schedule }),
  deleteRecipient: (recipient_id) => httpV2.delete(`teams/${recipient_id}`),
  undeleteRecipient: (recipient_id) =>
    httpV2.post(`teams/${recipient_id}/undelete`),
  inviteRecipient: (recipient_id) =>
    httpV2.post(`teams/${recipient_id}/invite`),
  rescindRecipient: (recipient_id) =>
    httpV2.post(`teams/${recipient_id}/rescind`),

  toggleInboxRestriction: (personal_inbox_id, token) =>
    httpV2.post(`/inbox/restrictions/toggle`, {
      personal_inbox_id: personal_inbox_id,
      token: token,
    }),
};

export default InboxService;
